import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingSpinner = ({ small = false }) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center ${
        small ? "" : "vh-100"
      }`}
    >
      <Spinner
        animation='border'
        role='status'
        size={small ? "sm" : undefined}
        style={{ color: "#F5A623" }}
      >
        <span className='visually-hidden'>Cargando...</span>
      </Spinner>
    </div>
  );
};

export default LoadingSpinner;
